(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvLoading', DrvLoading);

    DrvLoading.$inject = ['$timeout'];
    
    /**
     * @ngdoc directive
     * @name drvLoading
     *
     * @description
     * Presents a visual indication of "loading".
     *
     * @param {bool} loading - Set this to true to display the "loading" indication. Display will be
     * delayed according to the "displayDelay" value (default 500ms).
     * @param {number} displayDelay - Optional. The "loading" display won't display immediately after
     * "loading" is set to a true value, it will wait this many milliseconds before displaying.
     *
     * # Usage Example
     *
     * <drv-loading loading="vm.loading"></drv-loading>
     * <section ng-show="!vm.loading">
     *      <!-- The rest of the page content, to be hidden during loading -->
     * </section>
     */
    function DrvLoading($timeout) {
        var timeoutPromise = null;

        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                loading: '=',
                displayDelay: '=?'
            },
            template: '<section ng-show="displayLoading">Loading... <md-progress-circular md-mode="indeterminate"></md-progress-circular></section>'
        };
        return directive;

        function link(scope, element, attrs) {
            if (!angular.isDefined(scope.displayDelay) || scope.displayDelay === null) {
                scope.displayDelay = 500;
            }

            scope.$watch('loading', function (newVal, oldVal) {
                if (newVal) {
                    if (timeoutPromise === null) {
                        timeoutPromise = $timeout(function () {
                            timeoutPromise = null;
                            scope.displayLoading = true;
                        }, scope.displayDelay);
                    }
                } else {
                    if (timeoutPromise !== null) {
                        $timeout.cancel(timeoutPromise);
                        timeoutPromise = null;
                    }
                    scope.displayLoading = false;
                }
            });
        }
    }
})();